import { createContext, ReactNode, useContext, useState } from 'react';
import { ApplyJobStore } from './ApplyJob.store';

const ApplyJobContext = createContext<ApplyJobStore | null>(null);

export const ApplyJobProvider = ({ children }: { children: ReactNode }) => {
   const [store] = useState(() => new ApplyJobStore());
   return <ApplyJobContext.Provider value={store}>{children}</ApplyJobContext.Provider>;
};

export const useApplyJobCtx = () => {
   const ctx = useContext(ApplyJobContext);
   if (!ctx) {
      throw new Error('useApplyJobCtx must be used inside ApplyJobProvider');
   }
   return ctx;
};
